import ExportMatrix from './ExportMatrix';
import { buildCodeList } from './exportUtils';

const COL_OFFSET = 3;
const ROW_OFFSET = 2;

const DESCRIPTOR_OFFSET = 1;
const DESCRIPTOR_DESCRIPTION_OFFSET = DESCRIPTOR_OFFSET - 1;

const DESCRIPTOR_DESCRIPTION = '# of unique transcripts with this descriptor that have this code';
const TOTAL_ROW_LABEL = 'Total # of transcripts with this descriptor';

const EXPORT_NAME = 'Code x Descriptor Matrix';


// Build descriptor choices directly from descriptorsData
function getDescriptorChoices(descriptorsData) {
  if (!descriptorsData) return [];
  
  // Flatten all descriptor choices into a single list
  return descriptorsData.flatMap(descriptor => 
    (descriptor.multi_choices || []).map(choice => ({
      ...choice,
      descriptor_id: descriptor.id,
      name: descriptor.name
    }))
  );
}

const codesVDescriptorArray = (projectData, codesData, descriptorsData, reportData) => {
  const codes = buildCodeList(codesData);
  const projectName = projectData?.name || 'Project';
  // Handle nested report structure from API response
  const report = reportData?.data?.report || reportData?.report || reportData;
  const descriptorList = getDescriptorChoices(descriptorsData);

  // Older report payloads have no transcript_counts; only add the totals row
  // when the data is present.
  const transcriptCounts = report?.transcript_counts;
  const totalRowCount = transcriptCounts ? 1 : 0;

  const matrix = new ExportMatrix(codes.length + ROW_OFFSET + totalRowCount, descriptorList.length + COL_OFFSET);

  const descriptorNames = descriptorList.map((descriptor) => `${descriptor.name}: ${descriptor.choice}`);

  matrix.setCodeRows(codes, ROW_OFFSET, COL_OFFSET);
  matrix.setRow(descriptorNames.map(() => DESCRIPTOR_DESCRIPTION), DESCRIPTOR_DESCRIPTION_OFFSET, COL_OFFSET);
  matrix.setRow(descriptorNames, DESCRIPTOR_OFFSET, COL_OFFSET);

  if (report && report.multi_choices) {
    for (let descriptorIndex = 0; descriptorIndex < descriptorList.length; descriptorIndex++) {
      const { id } = descriptorList[descriptorIndex];
      const reportDescriptor = report.multi_choices[id];
      if (!reportDescriptor) continue;
      for (let codeIndex = 0; codeIndex < codes.length; codeIndex++) {
        const [code_id] = codes[codeIndex];
        const reportCode = reportDescriptor.codes[code_id];
        if (!reportCode) continue;
        const transcriptCount = reportCode.transcript_count;
        matrix.setValue(codeIndex + ROW_OFFSET, descriptorIndex + COL_OFFSET, transcriptCount);
      }
    }
  }

  if (transcriptCounts) {
    const totalRowIndex = codes.length + ROW_OFFSET;
    const CODE_NAME_OFFSET = COL_OFFSET - 1;
    matrix.setValue(totalRowIndex, CODE_NAME_OFFSET, TOTAL_ROW_LABEL);
    const totals = descriptorList.map((descriptor) => transcriptCounts[descriptor.id] || 0);
    matrix.setRow(totals, totalRowIndex, COL_OFFSET);
  }

  matrix.setHeaders(projectName, EXPORT_NAME);
  return matrix.toCSV();
};

// New signature: accepts clean data parameters instead of state
const exportCodesVDescriptorMapper = (projectData, codesData, descriptorsData, reportData) => {
  const projectName = projectData?.name || 'Project';
  const exportFileName = `${projectName}_CodeXDescriptor`;

  const matrix = codesVDescriptorArray(projectData, codesData, descriptorsData, reportData);

  return {
    projectName: exportFileName,
    matrix
  };
};

export default exportCodesVDescriptorMapper;